import React from "react";
import { useEffect, useState, useContext } from "react";
import { useNavigate, useSearchParams, useLocation, matchPath } from 'react-router-dom'
import Select from "react-select";
import axios from "axios";
import SglContext from '../SglContext'

function SglShowPicker(props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation()

  const [loading, setLoading] = useState(true);
  const [currentShow, setCurrentShow] = useState(null);
  const [showList, setShowList] = useState([]);
  const [urlShow, setURLShow] = useState("");
  const Sgl = useContext(SglContext)

  useEffect(() => {
    axios
      .get(Sgl.nestApiUrl + "/shows", {
        params: {
          customer_id: Sgl.company_id,
        },
      })
      .then((response) => {
        setLoading(false)

        let show_id = localStorage.getItem("show_id")
        localStorage.setItem("default_show_id", response.data.default_show);  //storing default show id in local-storage
        if (searchParams.get('sid') && !isNaN(searchParams.get('sid'))) { // In query string
          show_id = parseInt(searchParams.get('sid'))
        } else {

          let show_id_expiry_time = 0;
          if ( localStorage.getItem('show_id_expiry_time') === null ) {
            show_id_expiry_time = Date.now() + parseInt(process.env.REACT_APP_SHOW_ID_EXPIRY_TIME) 
            localStorage.setItem('show_id_expiry_time',show_id_expiry_time)  //storing expiry time for selected option        
          } else {
            show_id_expiry_time = parseInt( localStorage.getItem('show_id_expiry_time') );
          }

          //checking show_id doesn't exists or expiry time has reached then use default show
          if( !show_id || ( Date.now() > show_id_expiry_time ) ) {
            show_id_expiry_time = Date.now() + parseInt(process.env.REACT_APP_SHOW_ID_EXPIRY_TIME) 
            localStorage.setItem('show_id_expiry_time',show_id_expiry_time)  //storing expiry time for selected option        
            show_id = response.data.default_show;
          }
          
        }

        let allShows = response.data.shows.map(function (show) {
          show.label = show.show_name;
          show.value = show.show_id;
          show.date = show.display_date;

          if (show.show_id == show_id) {
            localStorage.setItem('show_id', show.show_id);
            setCurrentShow(show)
            props.onShowChange(show.show_id);
          }

          return show;
        })
        setShowList(allShows);
      });
  }, []);

  useEffect(() => { // if show id is present in URL then select it

    let sid = searchParams.get('sid')
    if (sid && !isNaN(sid)) {
      sid = parseInt(sid)

      if (currentShow && sid != currentShow.show_id) {
        let url_show = showList.find(show => {
          return show.show_id == sid
        })

        if (url_show) {
          url_show.label = url_show.show_name;
          url_show.value = url_show.show_id;
          url_show.date = url_show.display_date;

          onShowChange(url_show)
        }
      }
    }
    setURLShow(searchParams.get('sid') ? searchParams.get('sid') : '')
  }, [searchParams])

  const onShowChange = (option) => {
    setCurrentShow(option)
    localStorage.setItem('show_id', option.show_id);
    props.onShowChange(option.show_id);
    let show_id_expiry_time = Date.now() + parseInt(process.env.REACT_APP_SHOW_ID_EXPIRY_TIME) 
    localStorage.setItem('show_id_expiry_time',show_id_expiry_time)  //storing expiry time for selected option

    if (urlShow.length && parseInt(urlShow) != option.show_id) { // Go to listing page
      // Get listing page path from pathname
      let path;
      if (matchPath("/classes/detail", location.pathname)) {
        path = "classes"
      } else if (matchPath("/people/detail", location.pathname)) {
        path = "people"
      } else if (matchPath("/entries/detail", location.pathname)) {
        path = "horses-entries"
      } else if (matchPath("/classsignup/viewSetOrder", location.pathname) || matchPath("/classsignup/index", location.pathname)) {
        path = "orders-of-go-signups"
      } else if (matchPath("/circuitstanding/detail", location.pathname) || matchPath("/circuitstanding/detail/points", location.pathname)) {
        path = "circuit-standings"
      } else if (matchPath("/results/detail", location.pathname)) {
        path = "browse"
      } else if (matchPath("/ring/detail", location.pathname)) {
        path = "ring-status"
      }
      // let path = window.location.pathname[0] == '/' ? window.location.pathname.slice(1) : window.location.pathname
      // path = path.split('/')[0]


      // switch (path) {
      //   case 'classsignup':
      //     path = 'orders-of-go-signups/'
      //     break;
      //   case 'entries':
      //     path = 'horses-entries'
      //     break;
      //   case 'circuitstanding':
      //     path = 'circuit-standings'
      //     break;
      //   case 'ring':
      //     path = 'ring-status'
      //   default: // Do nothing
      // }

      navigate(path)

    }
  }

  // font-size: 11px;
  // width: 198px;
  // margin-right: 5px;
  // height: 16px;
  // white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;

  // To display show ID and date inside option container
  const formatOptionLabel = ({ label, date }) => (
    <div>
      <div style={{ fontWeight: "bold", fontSize: "12px", overflow:'hidden',display: 'inline-block',textOverflow: 'ellipsis',whiteSpace:'nowrap' }}>{label}</div>

      <div style={{ fontSize: "12px" }}>{date}</div>
    </div>
  );

  // Option container custom styling
  const React_Select_Styles = {
    option: (styles, { isFocused }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#0369a1" : "white",
        color: isFocused ? "white" : "#0369a1",
        cursor: "pointer",
        height: "45px",
        width: "100%",
        margin: "0px",
        padding: "8px 10px",
        lineHeight: "14px",
        borderBottom: "1px solid #999",
        fontFamily: `Helvetica Neue, Helvetica, Arial, sans-serif !important`,
        overflow:'hidden',
        textOverflow: 'ellipsis',
      };
    },
  };

  if (loading) {
    return null;
  }

  if (matchPath("/registration", location.pathname) ||
    matchPath("/login", location.pathname) ||
    matchPath("/verify-login", location.pathname) ||
    matchPath("/live-channels", location.pathname) ||
    matchPath("/demand-channels", location.pathname) ||
    matchPath("/special-events-live-streaming", location.pathname) ||
    matchPath("/videos", location.pathname) ||
    matchPath("/add-entry", location.pathname) ||
    matchPath("/digital-signature", location.pathname) ||
    matchPath("/edit-account", location.pathname) ||
    matchPath("/live-channels/detail", location.pathname) ||
    matchPath("/livestream", location.pathname) ||
    matchPath("/livestream/detail", location.pathname) ||
    matchPath("/liveclass", location.pathname) ||
    matchPath("/forgot-password", location.pathname) ||
    matchPath("/password-verification", location.pathname) ||
    matchPath("/confirm-email", location.pathname) ||
    matchPath("/registation-confirmation", location.pathname) ||
    matchPath("/liveclass/detail", location.pathname) ||
    matchPath("/videos/subscribe", location.pathname) ||
    matchPath("/videos/detail", location.pathname) ||
    matchPath("/user-requests/*", location.pathname) ||
    ((Sgl.hasUnsignedAgreements || !Sgl.hasDefaultPaymentMethod) && ['order-supplies', 'class-adds-drops', 'checkout-entries'].includes(location.pathname.replace(/^\/|\/$/g, "")))
  ) {
    return null;
  }
  else {
    return (
      <section className="dis" style={{ display: "flex", marginBottom: "10px" }}>
        <label>Select Show</label>
        <div>
          <Select
            value={currentShow}
            options={showList}
            formatOptionLabel={formatOptionLabel}
            styles={React_Select_Styles}
            onChange={(option) => {
              onShowChange(option);
            }}
            isSearchable={false}
          />
        </div>
      </section>
    );
  }

}

export default SglShowPicker;
